<template> <!--//Radiologia imagenes cr15 #16-98 2 piso cos 4-->
  <main class="bmd-layout-content">
    <div class="container my-4">
      <div class="card">
        <div class="card-header pt-3 pb-0" id="headingOne">
          <h3 class="mb-0">
            <button class="btn btn-link font-weight-bold text-muted" data-toggle="collapse" data-target="#collapseOne"
                    aria-expanded="true" aria-controls="collapseOne">
              ESTILOS GENERALES
            </button>
          </h3>
        </div>

        <div class="card-body">
          <div class="container">
            <!--
              * Inicio barra superior
             -->
            <div class="row pt-3 my-1  border border-right pb-2">
              <div class="col-12 text-uppercase font-weight-bold border-bottom pl-2">
                Cabecera
              </div>
              <!--
              * Inicio barra navegación
             -->
              <div class="col-12 border-bottom text-capitalize text-muted font-weight-bold pl-3">
                barra navegación
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Color del nombre de la pagina</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" placeholder="Escoger color"
                         v-model="general.cabecera.barraNavegacion.nombre.color" required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-2" v-model="general.cabecera.barraNavegacion.nombre.color"
                           aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Tamaño de fuente del nombre de la pagina</span><br>
                <input type="number" min="1" max="100" class="border col-6"
                       v-model="general.cabecera.barraNavegacion.nombre.font_size" placeholder="12" required>
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Color del texto Idiomas</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" placeholder="Escoger color"
                         v-model="general.cabecera.barraNavegacion.idioma.color" required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-2" v-model="general.cabecera.barraNavegacion.idioma.color"
                           aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Tamaño de fuente del texto Idiomas</span><br>
                <input type="number" min="1" max="100" class="border col-6"
                       v-model="general.cabecera.barraNavegacion.idioma.font_size" placeholder="12" required>
              </div>
              <!--
             * Finaliza barra navegación
            -->
              <div class="col-12 mt-3">
                <button
                  class="btnAplicarEstilo btn btn-outline-primary  py-1 px-5 py-0 text-primary mb-1"
                  @click="aplicarEstilos('cabecera')">
                  Aplicar
                </button>
              </div>
            </div>
            <!--
              * Finaliza barra superior
             -->
            <!--
              * Inicio pagina inicial
             -->
            <div class="row pt-3 mb-1 mt-4  border border-right pb-2">
              <div class="col-12 text-uppercase font-weight-bold border-bottom pl-2">
                Pagina de Inicio
              </div>
              <!--
             * Inicio Resuelve tus dudas
            -->
              <div class="col-12 border-bottom border-top text-capitalize text-muted font-weight-bold pl-3">
                Título resuelve tus dudas
              </div>
              <div class="col-md-4 mt-3">
                <span class="">Color del texto</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" v-model="general.paginaInicio.cabecera.color"
                         placeholder="Escoger color"
                         required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-3" v-model="general.paginaInicio.cabecera.color"
                           aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-3  mt-3">
                <span class="">Tamaño de fuente</span><br>
                <input type="number" min="1" max="100" class="border col-6"
                       v-model="general.paginaInicio.cabecera.font_size"
                       placeholder="12" required>
              </div>
              <!--
             * Finaliza Resuelve tus dudas
            -->
              <!--
              * Inicio titulos de categorias
             -->
              <div class="col-12 border-bottom border-top text-capitalize text-muted font-weight-bold pl-3 mt-3">
                categorias
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Color del titulo de las categoria</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" placeholder="Escoger color"
                         v-model="general.paginaInicio.grupoCategorias.color" required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-2" v-model="general.paginaInicio.grupoCategorias.color"
                           aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Tamaño de fuente del titulo de las categorias</span><br>
                <input type="number" min="1" max="100" class="border col-6"
                       v-model="general.paginaInicio.grupoCategorias.font_size" placeholder="12" required>
              </div>
              <!--
             * Finaliza titulos de categorias
            -->

              <div class="col-12 mt-3">
                <button
                  class="btnAplicarEstilo btn btn-outline-primary  py-1 px-5 py-0 text-primary mb-1"
                  @click="aplicarEstilos('paginaInicio')">
                  Aplicar
                </button>
              </div>
            </div>
            <!--
              * Finaliza pagina inicial
             -->
            <!--
              * Inicio pagina de contenidos (unaCategoria)
             -->
            <div class="row pt-3 mb-1 mt-4  border border-right pb-2">
              <div class="col-12 text-uppercase font-weight-bold border-bottom pl-2">
                pagina de contenidos
              </div>
              <!--
             * Inicio Resuelve tus dudas
            -->
              <div class="col-12 border-bottom border-top text-capitalize text-muted font-weight-bold pl-3">
                Menú de ubicación
              </div>
              <div class="col-md-4 mt-3">
                <span class="">Color del texto guia</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" v-model="general.unaCategoria.menuUbicacion.color"
                         placeholder="Escoger color"
                         required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-3" v-model="general.unaCategoria.menuUbicacion.color"
                           aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-3  mt-3">
                <span class="">Tamaño de fuente</span><br>
                <input type="number" min="1" max="100" class="border col-6"
                       v-model="general.unaCategoria.menuUbicacion.font_size"
                       placeholder="12" required>
              </div>
              <!--
             * Finaliza Resuelve tus dudas
            -->
              <!--
              * Inicio titulos de categorias
             -->
              <div class="col-12 border-bottom border-top text-capitalize text-muted font-weight-bold pl-3 mt-3">
                Titulo principal de la categorias
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Color del titulo principal</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" placeholder="Escoger color"
                         v-model="general.unaCategoria.tituloPrincipal.color" required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-2" v-model="general.unaCategoria.tituloPrincipal.color"
                           aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Tamaño de fuente del titulo principal</span><br>
                <input type="number" min="1" max="100" class="border col-6"
                       v-model="general.unaCategoria.tituloPrincipal.font_size" placeholder="12" required>
              </div>
              <div class="col-12 border-bottom border-top text-capitalize text-muted font-weight-bold pl-3 mt-3">
                Titulo secundario de la categorias
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Color del titulos secundario</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" placeholder="Escoger color"
                         v-model="general.unaCategoria.tituloSecundario.color" required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-2" v-model="general.unaCategoria.tituloSecundario.color"
                           aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-6 mt-3">
                <span class="">Tamaño de fuente del titulos secundario</span><br>
                <input type="number" min="1" max="100" class="border col-6"
                       v-model="general.unaCategoria.tituloSecundario.font_size" placeholder="12" required>
              </div>
              <!--
             * Finaliza titulos de categorias
            -->
              <div class="col-12 mt-3">
                <button
                  class="btnAplicarEstilo btn btn-outline-primary  py-1 px-5 py-0 text-primary mb-1"
                  @click="aplicarEstilos('unaCategoria')">
                  Aplicar
                </button>
              </div>
            </div>
            <!--
              * Finaliza pagina de contenido (unaCategoria)
             -->
            <div class="row pt-3 mt-4 border border-right pb-2">
              <div class="col-12 text-uppercase font-weight-bold border-bottom pl-2">
                Pie de pagina
              </div>
              <div class="col-12 border-bottom pb-2">
                <div class="row mt-3">
                  <div class="col-12 col-md-6 mt-1">
                    <label class="col-12 p-0 m-0">Cargar enlace de sitio web</label>
                    <input inpss="mt-2" type="text" v-model="general.footer.identidad.url_site"
                           placeholder="Escoger color" required>
                    <small id="emailHelp" class="form-text text-muted">http://ejemplo-miempresa.com</small>
                  </div>

                  <div class="col-12 col-md-6 mt-1">
                    <span class="">Color del enlace del sitio web</span>
                    <div class="input-group mb-3">
                      <input type="color" class="mt-2" v-model="general.footer.identidad.color"
                             placeholder="Escoger color"
                             required>
                      <div class="input-group-append">
                        <input type="text" class="form-control pl-2" v-model="general.footer.identidad.color"
                               placeholder="" required aria-describedby="basic-addon1">
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-5 mt-3">
                    <label>Cargar logo</label>
                    <div class="input-group mb-3 m-0 p-0">
                      <div class="custom-file mt-0">
                        <input type="file" class="form-control rounded" id="fileLogo" accept="image/*"
                               @change="getImage">
                      </div>
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">
                          <button type="button" class="btn btn-primary btn-outline-primary btn-sm"
                                  @click="limpiarLogo()">Limpiar</button>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <img :src="'http://'+general.footer.identidad.logo" class="img-fluid" width="80px" alt=""
                         v-if="tieneImagen">
                    <button class="btn text-center text-danger font-weight-bold d-inline mt-4" @click="removerLogo()">
                      <i class="fas fa-backspace fa-2x ml-4"></i>
                      Remover logo
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-md-3 mt-3">
                <span class="">Color de fondo</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" v-model="general.footer.fondo.background_color"
                         placeholder="Escoger color"
                         required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-2" v-model="general.footer.fondo.background_color"
                           placeholder="" required aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-3 mt-3">
                <span class="">Color de Enlaces</span>
                <div class="input-group mb-3">
                  <input type="color" class="mt-2" v-model="general.footer.texto.color" placeholder="Escoger color"
                         required>
                  <div class="input-group-append">
                    <input type="text" class="form-control pl-2" v-model="general.footer.texto.color"
                           placeholder="" required aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
              <div class="col-md-3 mt-3">
                <span class="">Tamaño de fuente</span>
                <input type="number" v-model="general.footer.texto.font_size" min="1" max="100"
                       class="border col-6" id="inputRangco" placeholder="12" required>
              </div>

              <div class="col-md-6 mt-3">
                <span class="">Nombre del enlace #1</span>
                <input type="text" v-model="general.footer.enlaces.enlace1.nombre" placeholder="Escoger color" required>
              </div>
              <div class="col-md-6  mt-3">
                <span class="">Enlace #1</span>
                <input type="url" v-model="general.footer.enlaces.enlace1.url" min="1" max="100"
                       class="border col-6" placeholder="12" required>
              </div>

              <div class="col-md-6 mt-3">
                <span class="">Nombre del enlace #2</span>
                <input type="text" v-model="general.footer.enlaces.enlace2.nombre" placeholder="Escoger color"
                       required>
              </div>
              <div class="col-md-6  mt-3">
                <span class="">Enlace #2</span>
                <input type="url" v-model="general.footer.enlaces.enlace2.url" min="1" max="100"
                       class="border col-6" placeholder="12" required>
              </div>

              <div class="col-12 mt-3">
                <button
                  class="btnAplicarEstilo btn btn-outline-primary  py-1 px-5 py-0 text-primary mb-1"
                  @click="aplicarEstilos('footer')">
                  Aplicar
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
  import servicioApi from "../../servicioApi";
  import estilosFomateadorJson from "../../../compartida/estilosFomateadorJson";

  export default {
    name: "estilo",
    data() {
      return {
        imagen: '',
        removerImg: false,
        general: {
          footer: {
            fondo: {background_color: ""},
            identidad: {url_site: '', logo: '', color: ''},
            texto: {color: "", font_size: ""},
            enlaces: {enlace1: {nombre: "", url: ""}, enlace2: {nombre: "", url: ""}},
          },
          cabecera: {
            barraNavegacion: {
              nombre: {color: '', font_size: ''},
              idioma: {color: '', font_size: ''}
            }
          },
          paginaInicio: {
            cabecera: {color: '', font_size: ''},
            grupoCategorias: {font_size: '', color: ''},
          },
          unaCategoria: {
            menuUbicacion: {font_size: '', color: ''},
            tituloPrincipal: {color: '', font_size: ''},
            tituloSecundario: {color: '', font_size: ''}
          }
        }
      }
    },
    created() {
      this.cargarEstilos();
    }
    ,
    computed: {
      tieneImagen() {
        if (this.general.footer.identidad.logo != '')
          return true;
        else
          false
      }
    }
    ,
    methods: {
      tooltop() {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }
      ,
      limpiarLogo() {
        this.imagen = '';
        $('#customFile').val('');
      }
      ,
      getImage(event) {
        this.imagen = event.target.files[0];
      },
      cargarEstilos() {
        servicioApi.rol_regular.estilos.getRegular().then(resp => {
          this.general = estilosFomateadorJson.formateadorEstiloPanelJson.cargarEstilo(resp.data.data);
        }).catch(e => {
        });
      },
      removerLogo() {
        this.general.footer.identidad.logo = '';
        this.removerImg = true;
      },
      aplicarEstilos(seccion) {
        this.general.footer.identidad.logo = this.imagen;
        var data = new FormData();

        let jsonEstilos = {};
        if (seccion == 'footer') {
          let url_site = this.general.footer.identidad.url_site.substring(0, 4);
          if (url_site != 'http')
            url_site = "http://" + this.general.footer.identidad.url_site;
          else
            url_site = this.general.footer.identidad.url_site;

          let url1 = this.general.footer.enlaces.enlace1.url.substring(0, 4);
          if (url1 != 'http')
            url1 = "http://" + this.general.footer.enlaces.enlace1.url;
          else
            url1 = this.general.footer.enlaces.enlace1.url;

          let url2 = this.general.footer.enlaces.enlace2.url.substring(0, 4);
          if (url2 != 'http')
            url2 = "http://" + this.general.footer.enlaces.enlace2.url;
          else
            url2 = this.general.footer.enlaces.enlace2.url;

          jsonEstilos = {
            nombre: "footer",
            estilo: {
              fondo: {"background-color": this.general.footer.fondo.background_color},
              identidad: {
                url_site: url_site,
                logo: '',
                color: this.general.footer.identidad.color
              },
              texto: {color: this.general.footer.texto.color, "font-size": this.general.footer.texto.font_size},
              enlaces: {
                enlace1: {
                  nombre: this.general.footer.enlaces.enlace1.nombre, url: url1
                },
                enlace2: {
                  nombre: this.general.footer.enlaces.enlace2.nombre, url: url2
                }
              },
            }
          };

          data.append('logo', this.imagen);
          data.append('nombre', jsonEstilos.nombre);

        } else if (seccion == 'cabecera') {
          jsonEstilos = {
            nombre: "cabecera",
            estilo: {
              barraNavegacion: {
                nombre: {
                  color: this.general.cabecera.barraNavegacion.nombre.color,
                  'font-size': this.general.cabecera.barraNavegacion.nombre.font_size
                },
                idioma: {
                  color: this.general.cabecera.barraNavegacion.idioma.color,
                  'font-size': this.general.cabecera.barraNavegacion.idioma.font_size
                }
              }
            }
          };
          data.append('nombre', jsonEstilos.nombre);
        } else if (seccion == 'paginaInicio') {
          jsonEstilos = {
            nombre: "paginaInicio",
            estilo: {
              cabecera: {
                color: this.general.paginaInicio.cabecera.color,
                'font-size': this.general.paginaInicio.cabecera.font_size
              },
              grupoCategorias: {
                'font-size': this.general.paginaInicio.grupoCategorias.font_size,
                color: this.general.paginaInicio.grupoCategorias.color
              },
            }
          };

          data.append('nombre', jsonEstilos.nombre);
        } else if (seccion == 'unaCategoria') {
          jsonEstilos = {
            nombre: "unaCategoria",
            estilo: {
              unaCategoria: {
                menuUbicacion: {
                  'font-size': this.general.unaCategoria.menuUbicacion.font_size,
                  color: this.general.unaCategoria.menuUbicacion.color
                },
                tituloPrincipal: {
                  color: this.general.unaCategoria.tituloPrincipal.color,
                  'font-size': this.general.unaCategoria.tituloPrincipal.font_size
                },
                tituloSecundario: {
                  color: this.general.unaCategoria.tituloSecundario.color,
                  'font-size': this.general.unaCategoria.tituloSecundario.font_size
                }
              }
            }
          };
          data.append('nombre', jsonEstilos.nombre);
        }

        data.append('estilo', JSON.stringify(jsonEstilos));
        data.append('_method', 'POST');
        servicioApi.rol_regular.estilos.post(data).then(resp => {
          this.removerImg = false;
          let estiloFormateado = estilosFomateadorJson.formateadorEstiloPanelJson.cargarEstilo(resp.data.data);
          this.imagen = '';
          $('#fileLogo').val('');
          this.general = estiloFormateado;
        }).catch(e => {
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .bmd-layout-content {
    min-height: 90vh;
  }

  .btnAplicarEstilo {
  }
</style>



// WEBPACK FOOTER //
// src/components/privada/regular/estilo/estilo.vue